import { SurveyConfig } from 'src/redux/slices/project/consts'
import { FieldConfig, SurveyProgress } from 'src/redux/slices/project/types'
import { getEntries } from 'src/redux/utils'
import { Project } from 'src/types/database-model'

import { AccordionDetails, Grid, Typography } from '@material-ui/core'

import SurveyTextField from './SurveyTextField'

type SurveySectionDetailsProps = {
  group: keyof SurveyProgress
  isDrawer?: boolean
}
const SurveySectionDetails: React.FC<React.PropsWithChildren<SurveySectionDetailsProps>> = ({
  children,
  group,
  isDrawer,
}) => {
  const config = SurveyConfig[group]
  const fields = config.fields
  return (
    <AccordionDetails>
      <Grid container spacing={3} direction='column' alignItems='center'>
        {!isDrawer && (
          <Grid item>
            <Typography variant='body2'>{config.description}</Typography>
          </Grid>
        )}
        {Object.entries(config.fields).map((arg) => {
          const [field, config] = arg as [keyof Project, FieldConfig]
          return (
            <SurveyTextField
              isDrawer={isDrawer}
              field={field}
              config={config}
              key={`survey-field-entry=${field}`}
            />
          )
        })}
        {
          // This can move out of grid for horizontal layout...
          children
        }
      </Grid>
    </AccordionDetails>
  )
}
export default SurveySectionDetails
